module.exports = __webpack_public_path__ + "7454b3b9dd0005a204e24f3ad4765f2b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/scarf-zig-red.png
// module id = 2002
// module chunks = 0